<ng-container *transloco="let t">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{config.header | confirmTranslate}}</h4>
    @if (!config.disableEscape) {
      <button type="button" class="btn-close" [attr.aria-label]="t('common.close')" (click)="close()"></button>
    }
  </div>
  <div class="modal-body" style="overflow-x: auto" [innerHtml]="(config.content | confirmTranslate)! | safeHtml">
  </div>
  <div class="modal-footer">
    @for(btn of config.buttons; track btn) {
      <div>
        <button type="button" class="btn btn-{{btn.type}}" (click)="clickButton(btn)">{{btn.text | confirmTranslate}}</button>
      </div>
    }
  </div>

</ng-container>
